import React, { useEffect } from 'react'
import SVG from 'react-inlinesvg'
import arrowLeft from '../../../_metronic/assets/custom-icons/arrowLeft.svg'
import arrowRight from '../../../_metronic/assets/custom-icons/arrowRight.svg'
import { useSelector } from 'react-redux';
import useUtils from './useUtils';

function Tab2({values, handleChange, setFieldValue, errors, touched}) {
  const {fetchUnits} = useUtils()
  const units = useSelector(state => state.unit?.records || []);

  const onSelection = (unit) => {
    if (!values.units.includes(unit.name)) {
      setFieldValue('units', [...values.units, unit.name]); 
      setFieldValue('unitIds', [...values.unitIds, unit.id]); 
    }
  };
  useEffect(() => {
    fetchUnits(values.languageId)
  }, [values.languageId])

  const onRemoveOne = (unitTitle) => {
    const unitIndex = values.units.indexOf(unitTitle); 
    if (unitIndex > -1) {

      const updatedUnits = values.units.filter((value) => value !== unitTitle);
      setFieldValue('units', updatedUnits);


      const updatedUnitIds = values.unitIds.filter((_, index) => index !== unitIndex);
      setFieldValue('unitIds', updatedUnitIds);
    }
  };


  const onRemoveAll = () => {
    setFieldValue('units', []); 
    setFieldValue('unitIds', []); 
  };


  const onSelectAll = () => {
    const allUnitTitles = units.map(unit => unit.name); 
    const allUnitIds = units.map(unit => unit.id); 
    setFieldValue('units', allUnitTitles);
    setFieldValue('unitIds', allUnitIds);
    console.log(values.units)
  };

  return (
    <div>
      <div className="d-flex align-items-start justify-content-center gap-10 flex-wrap">
        <div className='d-flex flex-column gap-5 text-gray-800 fw-bold fs-6'>
          All units
          <div className="pb-4 shadow-lg rounded-3 overflow-hidden" style={{ width: '340px', minHeight: '250px' }}>
            <div className=" d-flex justify-content-center align-items-center" style={{background:"#f5f8fa", height: '35px' }}>
              <div     style={{cursor:'pointer'}} onClick={onSelectAll}> 
                <span className={`svg-icon svg-icon-1 svg-icon-primary`}>
                  <SVG src={arrowRight} className='svg-icon-1 svg-icon-primary' />
                </span></div>
            </div>
            <div className="p-2 pt-7 c-black t-14 d-flex flex-column">            
            <div style={{height: '400px', overflowY: 'auto'}}>
                {units.map((unit, index) => (
                  <div key={index} className="d-flex gap-2">
                   <div style={{background:"#eff2f5"}} className='mb-5 rounded-circle border border-4 border-white h-20px w-20px'></div>
                    <div style={{cursor:'pointer'}} className='text-gray-800  fw-bold fs-6' onClick={() => onSelection(unit)}>{unit.name}</div>
                  </div>
                ))}
                </div>
            </div>
          </div>
        </div>

        <div  className='d-flex gap-5 flex-column text-gray-800 fw-bold fs-6'>
          Selected Units
          <div className="pb-4 shadow-lg rounded-3 overflow-hidden" style={{ width: '340px', minHeight: '250px' }}>
            <div className=" d-flex justify-content-center align-items-center"  style={{background:"#f5f8fa", height: '35px' }}>
            
            <div style={{cursor:'pointer'}} onClick={onRemoveAll}> <span className={`svg-icon svg-icon-1 svg-icon-primary`}>
                  <SVG src={arrowLeft} className='svg-icon-1 svg-icon-primary' />
                </span></div>
            </div>
            <div className="p-2 pt-7 c-black t-14 d-flex flex-column ">
            <div style={{height: '400px', overflowY: 'auto'}}>
                {values.units && values.units.map((unitTitle, index) => (
                  <div key={index} className="d-flex gap-2">
                  <div style={{background:"#eff2f5"}} className='mb-5 rounded-circle border border-4 border-white h-20px w-20px'></div>
                    <div className='text-gray-800  fw-bold fs-6' style={{cursor:'pointer'}} onClick={() => onRemoveOne(unitTitle)}>{unitTitle}</div>
                 </div>
                ))}
              </div>
            </div>
          </div>
          {touched.unitIds && errors.unitIds && (
            <div className='fv-plugins-message-container ms-3'>
              <span role='alert' className='text-danger'>
                {errors.unitIds}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Tab2
